<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fN9TRB/tc-custom/9781571317148.jpg?1703849065868" alt="This image is the cover for the book Gatekeeper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gatekeeper
      </h1>
      <p class="bookDescription body article font2">
        <b>A prize-winning poetry collection that delves into the dark wood of the digital underworld: “Impressive . . . thought-provoking.” —<i>Publishers Weekly</i> (starred review)</b><br/><br/> What is the deep web? A locked door. A tool for oppression and for revolution. “An emptying drain, driven by gravity.” And in Patrick Johnson’s <i>Gatekeeper</i>—selected by Khaled Mattawa as the winner of the 2019 Ballard Spahr Prize for Poetry—it is the place where connection is darkly transfigured by distance and power.<br/><br/> So we learn as Johnson’s speaker descends into his inferno, his Virgil a hacker for whom “nothing to stop him is reason enough to keep going,” his Beatrice the elusive Anon, another faceless user of the deep web. Here is unnameable horror—human trafficking, hitmen, terrorism recruitment. And here, too, is the lure of the beloved. But gone are the orderly circles of hell. Instead, Johnson’s map of the deep web is recursive and interrogatory, drawing inspiration and forms from the natural world and from science, as his speaker attempts to find a stable grasp on the complexities of this exhilarating and frightening digital world.<br/><br/> Spooky and spare, <i>Gatekeeper</i> is a striking debut collection and a suspenseful odyssey for these troubled times.<br/><br/> “These fascinating poems rest on the assumption that each of us has two selves: one that occupies space in the ‘real’ world and another that exists only in a movie that plays continuously at the back of our minds. With our hands on a computer keyboard, we have a third, cyborg, self. The poetic enactment of the splitting of these multiple selves is mesmerizing.” —Mary Jo Bang
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Johnson, Khaled Mattawa
      </h2>
      
      <p class="authorDescription body article"><B>Patrick Johnson</B> earned his MFA in poetry at Washington University in St. Louis and completed his undergraduate at University of Wisconsin-Madison. He is currently studying to become a physician assistant, and lives in Madison.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39ef1cfe